<template>
  <li>
    <div class="inner">
      <div class="image">
        <img :src="data.thumbnail_url" class="cover" v-if="data.thumbnail_url" :alt="data.space_name"/>
      </div>
      <div class="description">
        <h4 class="wt-md fg-light-grey property-name">{{ data.space_name }}</h4>
        <h3 class="wt-md fg-mid-grey lh-std title">
          {{ data.address_label }}
        </h3>
      </div>
      <div class="listing-footer">
        <div class="view-property formatted">
          <a :href="data.slug" target="_blank" v-if="data.status === 'published'">View Property</a>
        </div>

        <div class="action-list" v-if="data.actions.length">
          <div class="action" v-for="action in data.actions">
            <div class="view-property formatted" v-if="action === 'edit'">
              <a href="#" @click="doAction(action)">Edit Property</a>
            </div>
            <button type="button" class="icon" :class="[action]" @click="doAction(action)" v-else>
              <svg-icon :id="action"></svg-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
  </li>
</template>

<script>
export default {

  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  data () {
    return {}
  },

  computed: {},

  watch: {},

  created () {
  },

  mounted () {

  },

  methods: {

    doAction (action) {
      this.$emit('action', { record: this.data, action: action })
    },

  }
}
</script>
